import { DELETE_NOTIFICATION_MESSAGE } from '../constants';

// delete notification message by
export const doDeleteNotificationMessage =
  () =>
  async ({ dispatch }) =>
    dispatch({ type: DELETE_NOTIFICATION_MESSAGE });
